<template>
  <main-sidebar-item
    :label="$t(isMenuOpen ? 'common.collapse' : 'common.expand')"
    :icon="isMenuOpen ? 'tmi-menu-close' : 'menu'"
    @toggle="updateMenuState"
  />
</template>

<script setup lang="ts">
import MainSidebarItem from '@/components/layout/mainSidebar/MainSidebarItem.vue'
import { useMenuState } from '@/composition/menuState'

const { isMenuOpen, updateMenuState } = useMenuState()
</script>
